<style lang="scss" scoped>
.input-form {
  background-color: #eee;
  padding: 15px 15px 10px;
  margin: 0 0 10px;
  h2 {
    font-size: 14px;
    margin: 0 0 10px;
  }
}
.map {
  position: relative;
  padding-bottom: 75%;
  height: 0;
  overflow: hidden;
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100% !important;
    height: 100% !important;
  }
}
</style>

<template>
  <div class="google-map-input">
    <div class="input-form" v-if="isEditing">
      <h2>GoogleMap</h2>
      <div class="form-group">
        <input
          type="text"
          class="form-control"
          name="url"
          placeholder="iframe内のsrcを入力してください"
          v-model="url"
        />
      </div>
      <div class="btn-group">
        <a class="btn-green" @click="onEndEdit()">追加</a>
        <a class="btn-green" @click="onDeleteInput()">削除</a>
      </div>
    </div>
    <div class="input-preview" v-else>
      <div class="map">
        <iframe :src="url"></iframe>
      </div>
      <footer-menu
        :onBeginEdit="onBeginEdit"
        :onDeleteInput="onDeleteInput"
        :onPullUp="onPullUp"
        :onPullDown="onPullDown"
        :index="index"
      />
    </div>
  </div>
</template>

<script>
import footerMenu from './input-footer-menu.vue';

export default {
  props: {
    value: {},
    index: Number,
    id: String,
  },
  data() {
    return {
      isEditing: false,
      url: '',
    };
  },
  components: {
    'footer-menu': footerMenu,
  },
  computed: {
    bodyJSON() {
      return {
        value: {
          url: this.url,
        },
        action: 'map',
        id: this.id,
      };
    },
    valid() {
      return this.url.match(/^https:\/\/www\.google\.com\/maps\//);
    },
  },
  mounted() {
    this.url = this.value.url;
  },
  methods: {
    onBeginEdit() {
      this.isEditing = true;
    },
    onEndEdit() {
      this.url = this.url
        .replace(/(&lt;)/g, '<')
        .replace(/(&gt;)/g, '>')
        .replace(/(&quot;)/g, '"')
        .replace(/(&#39;)/g, "'")
        .replace(/(&amp;)/g, '&');
      if (!this.valid) {
        alert('srcを正しく入力してください。');
        return false;
      }
      this.isEditing = false;
    },
    onDeleteInput() {
      bus.$emit('delete-input', this.index);
    },
    onPullUp() {
      bus.$emit('pull-up-item', this.index);
    },
    onPullDown() {
      bus.$emit('pull-down-item', this.index);
    },
  },
};
</script>
